export const createManualInstagramStory = (id = `instagram-story-manual-${Date.now()}`) => ({
  id,
  stop_id: '',
  stop_name: 'Manual Story',
  title: 'New Story',
  visual_headline: '',
  visual_headline_segments: [],
  visual_overtitle: '',
  visual_overtitle_color: '#57bfdc',
  visual_overtitle_size_percent: 100,
  visual_headline_x_percent: 7.5,
  visual_headline_y_percent: 78,
  narration: '',
  caption: '',
  audio_url: '',
  audio_duration: 0,
  audio_source_text: '',
  audio_stale: false,
  voice_id: '',
  media_url: '',
  media_storage_path: '',
  media_content_type: '',
  media_fingerprint: '',
  media_filename: '',
  image_overlay_url: '',
  image_overlay_storage_path: '',
  image_overlay_content_type: '',
  image_overlay_fingerprint: '',
  image_overlay_filename: '',
  image_overlay_disabled: false,
  image_overlay_size_percent: 35,
  image_overlay_x_percent: 50,
  image_overlay_y_percent: 38,
  story_partner_logo_size_percent: 16,
  story_partner_logo_content_scale_percent: 140,
  story_partner_logo_padding_percent: 0,
  story_partner_logo_x_percent: 88,
  story_partner_logo_y_percent: 9,
  story_ken_burns_direction: 'dramatic_push',
  story_ken_burns_zoom: 1.25,
  rendered_video_url: '',
  rendered_video_storage_path: '',
});
